/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddPatchMenuDTO } from '../model/addPatchMenuDTO';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { GetMenuView } from '../model/getMenuView';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MenuService {

    protected basePath = 'https://demo-api.mensapp.it/gestione-mense';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Consente di aggiungere un menu in un comune.
     * Crea un nuovo menu per il comune specificato. Accetta un payload JSON con i dati del menu e un file allegato opzionale caricato su S3.
     * @param slugComune 
     * @param menu 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addMenuForm(slugComune: string, menu?: AddPatchMenuDTO, file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<GetMenuView>>;
    public addMenuForm(slugComune: string, menu?: AddPatchMenuDTO, file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GetMenuView>>>;
    public addMenuForm(slugComune: string, menu?: AddPatchMenuDTO, file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GetMenuView>>>;
    public addMenuForm(slugComune: string, menu?: AddPatchMenuDTO, file?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling addMenu.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (menu !== undefined) {
            formParams = formParams.append('menu', <any>menu) as any || formParams;
        }
        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<Array<GetMenuView>>('post',`${this.basePath}/api/v1/menu`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di rimuovere un menu.
     * Elimina un menu esistente e il relativo file allegato da S3, se presente.
     * @param id_menu 
     * @param slugComune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteMenu(id_menu: string, slugComune: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public deleteMenu(id_menu: string, slugComune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public deleteMenu(id_menu: string, slugComune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public deleteMenu(id_menu: string, slugComune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_menu === null || id_menu === undefined) {
            throw new Error('Required parameter id_menu was null or undefined when calling deleteMenu.');
        }

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling deleteMenu.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('delete',`${this.basePath}/api/v1/menu/${encodeURIComponent(String(id_menu))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di scaricare il file relativo ad un menù
     * Scarica il file allegato a un menu (es. PDF del menù) direttamente da S3.
     * @param id_menu 
     * @param nomeFile 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadMenu(id_menu: string, nomeFile: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public downloadMenu(id_menu: string, nomeFile: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public downloadMenu(id_menu: string, nomeFile: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public downloadMenu(id_menu: string, nomeFile: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_menu === null || id_menu === undefined) {
            throw new Error('Required parameter id_menu was null or undefined when calling downloadMenu.');
        }

        if (nomeFile === null || nomeFile === undefined) {
            throw new Error('Required parameter nomeFile was null or undefined when calling downloadMenu.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (nomeFile !== undefined && nomeFile !== null) {
            queryParameters = queryParameters.set('nomeFile', <any>nomeFile);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/v1/menu/${encodeURIComponent(String(id_menu))}/download`,
            {
             responseType: "blob" as "json",
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Restituisce i menu di un determinato comune.
     * Recupera la lista dei menu associati a un comune, filtrando opzionalmente per slug comune o per studente.
     * @param slugComune 
     * @param idStudente 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getListaMenu(slugComune?: string, idStudente?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<GetMenuView>>;
    public getListaMenu(slugComune?: string, idStudente?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GetMenuView>>>;
    public getListaMenu(slugComune?: string, idStudente?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GetMenuView>>>;
    public getListaMenu(slugComune?: string, idStudente?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (idStudente !== undefined && idStudente !== null) {
            queryParameters = queryParameters.set('idStudente', <any>idStudente);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<GetMenuView>>('get',`${this.basePath}/api/v1/menu`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consente di modificare un menu in un comune.
     * Aggiorna parzialmente un menu esistente. Permette di modificare i dati del menu e/o sostituire il file allegato su S3.
     * @param slugComune 
     * @param id_menu 
     * @param menu 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchMenuForm(slugComune: string, id_menu: string, menu?: AddPatchMenuDTO, file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<Array<GetMenuView>>;
    public patchMenuForm(slugComune: string, id_menu: string, menu?: AddPatchMenuDTO, file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GetMenuView>>>;
    public patchMenuForm(slugComune: string, id_menu: string, menu?: AddPatchMenuDTO, file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GetMenuView>>>;
    public patchMenuForm(slugComune: string, id_menu: string, menu?: AddPatchMenuDTO, file?: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling patchMenu.');
        }

        if (id_menu === null || id_menu === undefined) {
            throw new Error('Required parameter id_menu was null or undefined when calling patchMenu.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (menu !== undefined) {
            formParams = formParams.append('menu', <any>menu) as any || formParams;
        }
        if (file !== undefined) {
            formParams = formParams.append('file', <any>file) as any || formParams;
        }

        return this.httpClient.request<Array<GetMenuView>>('patch',`${this.basePath}/api/v1/menu/${encodeURIComponent(String(id_menu))}`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
